import {
    Box,
    FormControl,
    FormControlLabel,
    makeStyles,
} from "@material-ui/core";
import CheckBox from "@material-ui/core/Checkbox";
import React from "react";
import { Controller } from "react-hook-form";
import { isNotEmpty, isObjectNotEmpty } from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
    },
    root: {
        width: "80%",
    },
}));

export default function CustomCheckBox({
    control,
    label = "",
    name,
    required = true,
    showError = true,
    onChange = () => {},
    inputProps = {},
    fullWidth = false,
    toolTip = null,
    inlineText = false,
    errorStyle = {},
    boxStyle = {},
    labelStyle = {},
    ...rest
}) {
    const classes = useStyles();

    return (
        <Controller
            className={classes.root}
            control={control}
            name={name}
            render={({ field, fieldState: { error } }) => (
                <FormControl
                    error={isObjectNotEmpty(error)}
                    className={inlineText && classes.root}
                    style={boxStyle}
                >
                    <FormControlLabel
                        error={isNotEmpty(error?.sameAddress)}
                        style={labelStyle}
                        control={
                            <CheckBox
                                inputProps={{
                                    "aria-labelledby": name,
                                    ...inputProps,
                                }}
                                {...rest}
                                checked={field.value}
                                onChange={(e) => {
                                    field.onChange(e.target.checked);
                                    onChange(e);
                                }}
                            />
                        }
                        label={
                            isNotEmpty(label) && (
                                <span>
                                    {label}
                                    {required && (
                                        <Box
                                            component="span"
                                            className="danger"
                                        >
                                            *
                                        </Box>
                                    )}
                                    {isNotEmpty(toolTip) ? toolTip : null}
                                </span>
                            )
                        }
                    />
                    {showError && (
                        <ErrorMsg message={error?.message} style={errorStyle} />
                    )}
                </FormControl>
            )}
        />
    );
}
